<template>
  <v-form v-model="valid" ref="form">
      <v-row>
        <v-col cols="12">
          <h2 class="text-h4">
            <b>Unterlagen für die Angebotserstellung</b>
          </h2>
        </v-col>
        <v-col cols="12" md="8" lg="4">
          <v-file-input
            v-if="uploadReady"
            @change="selectFile"
            @click:clear="resetUpload"
            ref="fileupload"
            multiple
            label="Ihre Dateien max. 2GB"
            show-size
            :loading=loadingStatus
            class="mt-0 pt-0"
          ></v-file-input>
          <v-progress-linear
            v-if="loadingStatus"
            v-model="progress"
            color="deep-orange"
            height="25"
          >
            <template v-slot:default="{ value }">
              <strong>{{ Math.ceil(value) }}%</strong>
            </template>
          </v-progress-linear>
          <v-alert
            v-if="this.errors[0]"
            colored-border
            type="error"
            elevation="0"
            dense
          >
            Entschuldigung: Es ist ein Fehler aufgetreten.
          </v-alert>
        </v-col>
        <v-col cols="12" md="4" lg="3" >
          <v-btn
            v-if="!loadingStatus"
            :class="[uploadBtnAnimation ? 'animated pulse' : '']"
            color="primary"
            dark
            small
            depressed
            @click="upload">
            Hochladen
            <v-icon right dark>mdi-cloud-upload</v-icon>
          </v-btn>
          <v-tooltip
            right
            max-width="400"
            style="display: inline-block"
            class="pl-4"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                dark
                dense
                middle
                v-bind="attrs"
                v-on="on"
              >
                mdi-information-outline
              </v-icon>
            </template>
            Hinweis: Die Daten werden direkt hochgeladen.
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row
        v-if="filesData.uploadStatus"
      >
        <v-col cols="12">
          <b>Ihre bisher hochgeladenen Dateien</b>
          <ul class="file-list">
            <li v-for="item in filesData.uploadFiles" :key="item.id">
              {{ item.name }}
            </li>
          </ul>
          <!--
          <v-btn
            @click="resetUpload()"
            color="primary"
            dark
            small
            depressed
          >
            <v-icon dark>
              mdi-delete
            </v-icon>
            Dateien zurücksetzen
          </v-btn>
          -->
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <small>Alternativ können Sie uns die Unterlagen gerne per Mail zukommen lassen.
            Bitte geben Sie hierfür folgende Anfragenummer an. </small>
          <v-chip
            color="red"
            text-color="white"
          >{{ project.code }}</v-chip>
        </v-col>
      </v-row>
  </v-form>

</template>

<script>

import {DCFORMSERVICE} from "../http-common";

export default {
  name: "upload-files",
  props: {
    project: {
      required: true,
      type: Object
    }
  },
  data: function () {
    return {
      errors: [],
      uploadReady: true,
      valid: false,
      loadingStatus: false,
      progress: 0,
      uploadBtnAnimation: false,
      currentFiles: undefined,
      filesData: {
        uploadStatus: false,
        uploadFiles: [],
      },
      fileRules: [
        v => !!v || 'Keine Datei. Bitte in das Feld klicken und Ihre Dateien auswählen.',
        //v => !v || v.size < 100000000 || 'Dateigröße muss kleiner als 100 MB sein!',
      ],
    };
  },
  watch: {
    filesData: {
      handler() {
        localStorage.setItem('dcformFilesData', JSON.stringify(this.filesData));
      },
      deep: true,
    },
  },
  mounted() {
    if (localStorage.getItem('dcformFilesData')) this.filesData = JSON.parse(localStorage.getItem('dcformFilesData'));
  },

  computed: {
  },
  methods: {
    validate () {
      this.$refs.form.validate()
    },
    selectFile(file) {
      this.currentFiles = file;
      this.progress = 0;
      if (file !== undefined && file.length > 0) {
        this.uploadBtnAnimation = true;
      }
    },
    resetUpload() {
      //console.log('reset');
      this.currentFiles = undefined;
      this.loadingStatus =  false;
      //this.filesData.uploadFiles.length = 0;
      //this.filesData.uploadStatus = false;
      this.errors = [];
      this.uploadBtnAnimation = false;
    },
    clearUploadAfterSubmit () {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    /*
    updateParentLogoFileID() {
      this.$emit('update:logoFileID', this.logoFileID);
      this.$emit('validate-parent');
    },
    */
    upload() {

      this.validate();

      if(this.valid ) {
        if(this.currentFiles !== undefined) {
          let appData = this;

          let formData = new FormData();
          this.currentFiles.forEach(file=>{
            formData.append("uploads", file);
          });

          this.loadingStatus = true;

          DCFORMSERVICE ({
            method: 'post',
            url: 'upload/' + this.project.id,
            data: formData,
            onUploadProgress: function(progressEvent) {
              let progress = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
              appData.progress = progress;
            },
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
            .then(function (response) {
              //handle success
              appData.loadingStatus = false;
              appData.filesData.uploadStatus = true;
              if (response.data.uploads !== '') {
                appData.filesData.uploadFiles = response.data.uploads;
              }
              //appData.currentFiles=undefined
              //appData.$refs.fileupload.value=''
              appData.clearUploadAfterSubmit();
              appData.currentFiles=undefined;
              appData.uploadBtnAnimation = false;
            })
            .catch(function (error) {
              //handle error
              appData.filesData.uploadStatus = false;
              appData.errors.push(error);
              console.log(error);
              console.log(error.response);
            });
        }

      }

    }
  }
};

</script>

<style lang="scss">
.file-list {
  margin-left:0;
  margin-top: 1rem;
}

.animated {
  animation-fill-mode:both;
  animation-duration:1s;
  animation-iteration-count: infinite;
}

.stopanimation {
  animation-iteration-count: revert;
}

@-moz-keyframes pulse {
  0% { -moz-transform: scale(1); }
  50% { -moz-transform: scale(1.1); }
  100% { -moz-transform: scale(1); }
}
@-o-keyframes pulse {
  0% { -o-transform: scale(1); }
  50% { -o-transform: scale(1.1); }
  100% { -o-transform: scale(1); }
}
@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

.pulse {
  -webkit-animation-name: pulse;
  -moz-animation-name: pulse;
  -o-animation-name: pulse;
  animation-name: pulse;
}
</style>
